import React, { useEffect, useState } from "react";
import socket from "../../assets/socketConnection";
import { socketServer } from "../../assets/socketConnection";
import { selectUserToken } from "../../redux/user/user.selectors";
import { useSelector } from "react-redux";
import Jetons from "../../containerSmall/jetons/jetons.component";
import { JetonPageStyled, BoxStyled, JetonBtn } from "./jeton.styles";
const Jeton = () => {
  const userToken = useSelector(selectUserToken);
  const [jetons, setJetons] = useState();
  useEffect(() => {
    socket.emit("get_my_points", {});
    socket.on("response_my_points", (jeton) => {
      console.log("jeton", jeton);
      setJetons(jeton);
    });
  }, []);
  const RedirectToUrl = () => {
    window.open(`${socketServer}club/${userToken}`, "_blank")
    console.log("link",);
  };
  return (
    <JetonPageStyled>
      <BoxStyled>
        {jetons &&
          jetons.map((jeton, index) => <Jetons key={index} jeton={jeton} />)}
        <Jetons />
      </BoxStyled>
      <JetonBtn onClick={RedirectToUrl}>تبدیل ژتون به پول نقد</JetonBtn>
    </JetonPageStyled>
  );
};

export default Jeton;
